import { useMemo, useState } from 'react';

import type { ColumnDraft, FilteredColumnRow } from '../types';

type Params = {
  columns: ColumnDraft[];
};

export function useColumnFilter({ columns }: Params) {
  const [searchText, setSearchText] = useState('');
  const [destinationFilter, setDestinationFilter] = useState<'all' | ColumnDraft['destination']>('all');

  const contractColumnNames = useMemo(() => columns.filter((c) => c.destination === 'contract').map((c) => c.name), [columns]);
  const customerColumnNames = useMemo(() => columns.filter((c) => c.destination === 'customer').map((c) => c.name), [columns]);

  const counts = useMemo(() => {
    let customer = 0;
    let contract = 0;
    let ignore = 0;
    for (const c of columns) {
      if (c.destination === 'customer') customer++;
      else if (c.destination === 'contract') contract++;
      else ignore++;
    }
    return { all: columns.length, customer, contract, ignore };
  }, [columns]);

  const filteredColumns: FilteredColumnRow[] = useMemo(() => {
    const q = searchText.trim().toLowerCase();
    return columns
      .map((col, index) => ({ col, index }))
      .filter(({ col }) => {
        if (destinationFilter !== 'all' && col.destination !== destinationFilter) return false;
        if (q && !col.name.toLowerCase().includes(q)) return false;
        return true;
      });
  }, [columns, destinationFilter, searchText]);

  return {
    searchText,
    setSearchText,
    destinationFilter,
    setDestinationFilter,
    filteredColumns,
    counts,
    contractColumnNames,
    customerColumnNames,
  };
}
